(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-light-demo]').forEach(demo => {
      if (demo.dataset.ready) return;
      demo.dataset.ready = 'true';
      const button = demo.querySelector('button');
      const onImage = demo.querySelector('.gm-light-on');
      let pinned = false, hovering = false, available = false;
      const render = () => {
        const lit = available && (pinned || hovering);
        demo.classList.toggle('is-lit', lit);
        button.setAttribute('aria-pressed', String(lit));
      };
      const ready = () => { available = onImage.naturalWidth > 0; button.disabled = !available; render(); };
      onImage.addEventListener('load', ready);
      if (onImage.complete) ready();
      demo.querySelector('.gm-light-stage').addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; render(); } });
      demo.querySelector('.gm-light-stage').addEventListener('pointerleave', () => { hovering = false; render(); });
      button.addEventListener('click', () => { pinned = !pinned; hovering = false; render(); });
      demo.addEventListener('keydown', event => { if (event.key === 'Escape') { pinned = false; hovering = false; render(); } });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
